import type { ContatoDoHistorico } from "@base/contracts";
import { Tabela } from "@base/ui";
import { descreverIntervalo, type Intervalo } from "../../../shared/periodo/periodos";
import { formatar } from "../domain/formatadores";
import { COLUNAS_DA_OPORTUNIDADE } from "./colunas-da-oportunidade";

export function HistoricoDeContatos({
  dados,
  total,
  carregando,
  periodo,
}: {
  readonly dados: readonly ContatoDoHistorico[];
  readonly total: number;
  readonly carregando: boolean;
  readonly periodo: Intervalo;
}) {
  return (
    <section aria-labelledby="titulo-historico-contatos" className="flex flex-col gap-bloco">
      <div className="flex flex-col gap-1">
        <h2 id="titulo-historico-contatos" className="text-xl font-normal tracking-tight">
          Histórico de conversões
        </h2>
        <p className="text-sm text-muted-foreground">
          Contatos com lead em {descreverIntervalo(periodo)}. Só as oportunidades desse período e dos filtros do
          topo.
        </p>
      </div>

      <div className="flex h-[28rem] flex-col overflow-hidden rounded-3xl bg-card shadow-sm ring-1 ring-border/70">
        <div className="min-h-0 flex-1 overflow-y-auto">
          {carregando && dados.length === 0 ? (
            <p className="px-5 py-8 text-sm text-muted-foreground">Carregando contatos…</p>
          ) : dados.length === 0 ? (
            <p className="px-5 py-8 text-sm text-muted-foreground">Nenhum contato com lead no período.</p>
          ) : (
            <ul className="divide-y divide-border/70">
              {dados.map((contato) => (
                <li key={contato.contatoId}>
                  <details className="group">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left marker:content-none [&::-webkit-details-marker]:hidden">
                      <span className="flex min-w-0 flex-col">
                        <span className="truncate font-medium">{contato.nome}</span>
                        <span className="text-xs text-muted-foreground">
                          {contato.criadoEm ? `Contato desde ${formatar.data(contato.criadoEm)}` : `Contato #${contato.contatoId}`}
                        </span>
                      </span>
                      <span className="shrink-0 text-xs text-muted-foreground">
                        {contato.oportunidades.length}{" "}
                        {contato.oportunidades.length === 1 ? "oportunidade" : "oportunidades"}
                      </span>
                    </summary>
                    <div className="border-t border-border/70 px-2 pb-3">
                      <Tabela
                        colunas={COLUNAS_DA_OPORTUNIDADE}
                        itens={contato.oportunidades}
                        chaveDe={(item) => String(item.leadId)}
                        legenda={`Oportunidades de ${contato.nome}`}
                      />
                    </div>
                  </details>
                </li>
              ))}
            </ul>
          )}
        </div>
        {total > dados.length ? (
          <p className="shrink-0 border-t border-border/70 px-5 py-3 text-xs text-muted-foreground">
            Mostrando {dados.length} de {total}.
          </p>
        ) : dados.length > 0 ? (
          <p className="shrink-0 border-t border-border/70 px-5 py-3 text-xs text-muted-foreground">
            {total} {total === 1 ? "contato" : "contatos"}
          </p>
        ) : null}
      </div>
    </section>
  );
}
